document.addEventListener("DOMContentLoaded", function () {
  const setupModal = (
    modalSelector,
    showButtonSelector,
    closeButtonSelector
  ) => {
    const modal = document.querySelector(modalSelector);
    const showButton = document.querySelectorAll(showButtonSelector);
    const closeButton = document.querySelectorAll(closeButtonSelector);

    if (modal && showButton && closeButton) {
      const showModal = () => {
        if (modal.showModal) {
          modal.showModal();
        } else {
          modal.setAttribute("open", "");
        }

        modal.classList.add("open-animation");
        modal.classList.remove("close-animation");

        document.body.classList.add("overflow-hidden");
      };

      const closeModal = () => {
        modal.classList.remove("open-animation");
        modal.classList.add("close-animation");

        modal.addEventListener(
          "animationend",
          () => {
            if (modal.close) {
              modal.close();
            } else {
              modal.removeAttribute("open");
            }
            document.body.classList.remove("overflow-hidden");
          },
          { once: true }
        );
      };

      showButton.forEach((button) => {
        button.addEventListener("click", showModal);
      });

      closeButton.forEach((button) => {
        button.addEventListener("click", closeModal);
      });

      window.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && modal.getAttribute("open") !== null) {
          closeModal();
        }
      });

      const modalLinks = modal.querySelectorAll("a");
      modalLinks.forEach((link) => {
        link.addEventListener("click", closeModal);
      });
    }
  };

  setupModal("[data-menu]", "[data-menu-show]", "[data-menu-close]");
});
